import { Icons } from "./icons";
import type { TimeframeInfo } from "../data/types";

export class TopToolbar {
  el: HTMLElement;
  private tfButtons = new Map<string, HTMLElement>();
  private crosshairBtn!: HTMLElement;
  private volumeBtn!: HTMLElement;
  private dszBtn!: HTMLElement;

  constructor(
    el: HTMLElement,
    opts: {
      symbol: string;
      timeframes: TimeframeInfo[];
      onSelectTf: (tf: string) => void;
      onGoToDate: () => void;
      onToggleCrosshair: () => void;
      onToggleVolume: () => void;
      onToggleDSZone: () => void;
      onFullscreen: () => void;
      onShortcuts: () => void;
      onReset: () => void;
      onFit: () => void;
    }
  ) {
    this.el = el;
    this.build(opts);
  }

  private build(opts: any) {
    const el = this.el;
    el.innerHTML = "";

    const sym = document.createElement("div");
    sym.className = "symbol-badge";
    sym.innerHTML = `<span>${opts.symbol}</span><span class="sym-sub">Micro E-mini Nasdaq-100 · CME</span>`;
    el.appendChild(sym);

    el.appendChild(this.sep());

    // timeframe group
    const tfGroup = document.createElement("div");
    tfGroup.className = "tb-group";
    for (const tf of opts.timeframes as TimeframeInfo[]) {
      const b = document.createElement("button");
      b.className = "tb-btn tf-btn";
      b.textContent = tf.label;
      b.title = `Timeframe ${tf.label}`;
      b.addEventListener("click", () => opts.onSelectTf(tf.tf));
      tfGroup.appendChild(b);
      this.tfButtons.set(tf.tf, b);
    }
    el.appendChild(tfGroup);

    el.appendChild(this.sep());

    // chart-type indicator (candles)
    const candles = document.createElement("button");
    candles.className = "tb-btn active";
    candles.innerHTML = Icons.candles;
    candles.title = "Candlestick";
    el.appendChild(candles);

    this.crosshairBtn = this.iconBtn(Icons.crosshair, "Toggle crosshair (C)", opts.onToggleCrosshair);
    this.crosshairBtn.classList.add("active");
    el.appendChild(this.crosshairBtn);

    this.volumeBtn = this.iconBtn(Icons.candles, "Toggle volume (Shift+V)", opts.onToggleVolume);
    // reuse an icon; set text label instead
    this.volumeBtn.innerHTML = `<span style="font-size:12px;font-weight:600">Vol</span>`;
    this.volumeBtn.classList.add("active");
    el.appendChild(this.volumeBtn);

    this.dszBtn = document.createElement("button");
    this.dszBtn.className = "tb-btn active";
    this.dszBtn.innerHTML = `<span style="font-size:12px;font-weight:700;letter-spacing:.3px">DSzone</span>`;
    this.dszBtn.title = "Toggle DSzone supply/demand indicator";
    this.dszBtn.addEventListener("click", opts.onToggleDSZone);
    el.appendChild(this.dszBtn);

    el.appendChild(this.iconBtn(Icons.calendar, "Go to date (G)", opts.onGoToDate));

    el.appendChild(this.sep());
    el.appendChild(this.iconBtn(Icons.fit, "Fit to data (Shift+R)", opts.onFit));
    el.appendChild(this.iconBtn(Icons.reset, "Reset chart (Alt+R)", opts.onReset));

    const spacer = document.createElement("div");
    spacer.className = "tb-spacer";
    el.appendChild(spacer);

    el.appendChild(this.iconBtn(Icons.keyboard, "Keyboard shortcuts (?)", opts.onShortcuts));
    el.appendChild(this.iconBtn(Icons.fullscreen, "Fullscreen (Shift+F)", opts.onFullscreen));
  }

  private sep(): HTMLElement {
    const s = document.createElement("div");
    s.className = "tb-sep";
    return s;
  }

  private iconBtn(icon: string, title: string, onClick: () => void): HTMLElement {
    const b = document.createElement("button");
    b.className = "tb-btn";
    b.innerHTML = icon;
    b.title = title;
    b.addEventListener("click", onClick);
    return b;
  }

  setActiveTf(tf: string) {
    for (const [id, b] of this.tfButtons) b.classList.toggle("active", id === tf);
  }
  setCrosshair(on: boolean) {
    this.crosshairBtn.classList.toggle("active", on);
  }
  setVolume(on: boolean) {
    this.volumeBtn.classList.toggle("active", on);
  }
  setDSZone(on: boolean) {
    this.dszBtn.classList.toggle("active", on);
  }
}
